import { Spinfinity, Typography } from 'components';
import useMainFindingsWithActions from 'hooks/useMainFindingsWithActions';
import { MainFindingItem } from '../SummaryCards/NoteCard/MainFindingItem';
import styles from './MainFindingsCards.module.css';

type Props = {
  currentKitId?: string;
};

export default function MainFindingsCards({ currentKitId }: Props) {
  const { findingsWithActions, isPending } =
    useMainFindingsWithActions(currentKitId);

  return (
    <div className={styles.container}>
      <div className={styles.horizontalSeparator} />
      <Typography variant='body-s' className={styles.title}>
        These are the areas we recommend focusing on first:
      </Typography>
      {isPending ? (
        <div className={styles.spinnerContainer}>
          <Spinfinity />
        </div>
      ) : (
        findingsWithActions.map(({ metric, relatedActions }) => (
          <MainFindingItem
            key={metric.sample_health_id}
            metric={metric}
            kitId={currentKitId}
            relatedActions={relatedActions}
          />
        ))
      )}
    </div>
  );
}
